// utility contexts to hold common simple global values
import { createContext, useContext } from 'react';

let bearerTokenContext = null;
let participantContext = null;
let tenantContext = null;
let publicURLContext = null;
let returnURLContext = null;
let appContainerContext = null; // a top-level DOM ref to mount overlays/modals to
let reCaptchaSiteKeyContext = null;
let privacyPolicyURLContext = null;
let termsofUseURLContext = null;


export function SetBearerTokenContext(value) {
    bearerTokenContext = createContext(value);
    return bearerTokenContext;
}

export function useBearerTokenContext() {
    return useContext(bearerTokenContext);
}

export function SetParticipantContext(value) {
    participantContext = createContext(value);
    return participantContext;
}

export function useParticipantContext() {
    return useContext(participantContext);
}

export function SetTenantContext(value) {
    tenantContext = createContext(value);
    return tenantContext;
}

export function useTenantContext() {
    return useContext(tenantContext);
}

export function SetPublicURLContext(value) {
    publicURLContext = createContext(value);
    return publicURLContext;
}

export function usePublicURLContext() {
    return useContext(publicURLContext);
}

export function SetPrivacyPolicyURLContext(value) {
    privacyPolicyURLContext = createContext(value);
    return privacyPolicyURLContext;
}

export function usePrivacyPolicyURLContext() {
    return useContext(privacyPolicyURLContext);
}

export function SetTermsofUseURLContext(value) {
    termsofUseURLContext = createContext(value);
    return termsofUseURLContext;
}

export function useTermsofUseURLContext() {
    return useContext(termsofUseURLContext);
}

export function SetReturnURLContext(value) {
    returnURLContext = createContext(value);
    return returnURLContext;
}

export function useReturnURLContext() {
    return useContext(returnURLContext);
}

export function SetAppContainerContext(value) {
    appContainerContext = createContext(value);
    return appContainerContext;
}

export function useAppContainerContext() {
    return useContext(appContainerContext);
}

export function SetReCaptchaSiteKeyContext(value) {
    reCaptchaSiteKeyContext = createContext(value);
    return reCaptchaSiteKeyContext;
}

export function useReCaptchaSiteKeyContext() {
    return useContext(reCaptchaSiteKeyContext);
}

